module.exports = __webpack_public_path__ + "media/images/flags/32/Morocco-2e8145555f29b75ffeace09c762e0383.png";